<div class="inner-about-wrap">
    <div class="container">
       <div class="row">
          <div class="col-lg-8">
             <div class="about-content">
                <figure class="about-image">
                   <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/d088a256-b289-440e-da38-b2119429c200/public" alt="">
                   <div class="about-image-content">
                     <!-- Photo by <a href="https://unsplash.com/@franckinjapan?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Franck</a> on <a href="https://unsplash.com/photos/black-iphone-5-on-yellow-textile-DoWZMPZ-M9s?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
  
                      <h3>Contenido privado</h3>
                      <div style="margin: 1rem auto;">
                        <a href="javascript: void(0)" (click)="openModal()" class="round-btn" style="background-color: #FFF; color: #3A78C9">Mostrar contenido</a>
                     </div>
                   </div>
                </figure>
                <h2>Ingresa la contraseña para mostrar el contenido</h2>
                <div>
                    <a href="javascript: void(0)" (click)="openModal()" class="round-btn">Mostrar contenido</a>
                 </div>
            </div>
           
          </div>
          
       </div>
    </div>
 </div>